function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

import React from "react";
export default ((_ref) => {
  let {
    styles = {}
  } = _ref,
      props = _objectWithoutProperties(_ref, ["styles"]);

  return <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 14 14" {...props}><path d="M3.889 14L7 10.889 10.111 14H3.89zm8.555-14H14v9.333h-1.556V0zm-3.11 0h1.555v6.222H9.333V0zM6.221 0h1.556v9.333H6.222V0zm-3.11 0h1.555v6.222H3.11V0zM0 0h1.556v9.333H0V0z" /></svg>;
});